import { createAction } from 'redux-actions'

const ns = 'notification-preferences/'

export const getUserPreferences = createAction(`${ns}GET_USER_PREFERENCES`)
export const getUserPreferencesSuccess = createAction(`${ns}GET_USER_PREFERENCES_SUCCESS`)
export const getUserPreferencesFail = createAction(`${ns}GET_USER_PREFERENCES_FAIL`)

export const editUserPreferences = createAction(`${ns}EDIT_USER_PREFERENCES`)
export const editUserPreferencesSuccess = createAction(`${ns}EDIT_USER_PREFERENCES_SUCCESS`)
export const editUserPreferencesFail = createAction(`${ns}EDIT_USER_PREFERENCES_FAIL`)

export const cancelUserPreferences = createAction(`${ns}CANCEL_USER_PREFERENCES`)
